import { render, staticRenderFns } from "./Probability.vue?vue&type=template&id=2ba5967f"
import script from "./Probability.vue?vue&type=script&lang=js"
export * from "./Probability.vue?vue&type=script&lang=js"
import style0 from "./Probability.vue?vue&type=style&index=0&id=2ba5967f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports